/******************************************************************************
 * Copyright (c) 2026 Contributors to the Eclipse Foundation.
 *
 * See the NOTICE file(s) distributed with this work for additional
 * information regarding copyright ownership.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * https://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *****************************************************************************/

import { useQuery } from '@tanstack/react-query';
import { sendRequest } from 'openvsx-webui';

type MembershipLevel = 'SD' | 'AP' | 'AS';

interface Member {
  organization_id: number;
  name: string;
  logos: {
    web: string | null;
  };
  website: string;
  levels: {
    level: MembershipLevel;
    description: string;
    sort_order: string;
  }[];
}

/** The members of an Eclipse working group, from the Eclipse membership API. */
export const useMembers = (collaborationId: string) =>
  useQuery({
    queryKey: ['members', collaborationId],
    queryFn: ({ signal }) =>
      sendRequest<Member[]>({
        signal,
        endpoint: `https://membership.eclipse.org/api/organizations?working_group=${encodeURIComponent(collaborationId)}`
      })
  });
